import type { ReactNode } from 'react'
import css from './FormColumn.module.css'

interface FormColumnProps {
    children: ReactNode
    align?: 'stretch' | 'start' | 'center' | 'end' | 'left'
    flex?: string | number
    width?: number
    gap?: string | number
}

const FormColumn = ({ children, align = 'stretch', flex, width, gap }: FormColumnProps) => {
    const alignValue = align === 'left' ? 'flex-start' : align
    const flexValue = typeof flex === 'number' ? flex : `0 0 ${flex}px`
    const gapValue = typeof gap === 'number' ? `${gap}px` : gap

    const style: React.CSSProperties = {
        alignItems: alignValue,
        flex: flex ? flexValue : width ? `0 0 ${width}px` : 1,
        ...(gap !== undefined && { gap: gapValue })
    }

    return (
        <div className={css.form_column} style={style}>
            {children}
        </div>
    )
}

export default FormColumn
